// @flow strict
function range(from: number, to: number): Array<number> {
  return Array.from({ length: to - from }, (v, i) => i + from);
}

const removeDuplicates = (array: Array<*>): Array<*> =>
  array.filter((a, b) => array.indexOf(a) === b);

export { range, removeDuplicates };
